export const HOME_COUNTRY_BUTTON = 'home-country-button';
export const FOREIGN_COUNTRY_BUTTON = 'foreign-country-button';
export const DIALOG = 'dialog';
